import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useIntl, FormattedMessage } from 'react-intl';
import CustomTypography from '../../../components/Typography/CustomTypography';
import Button from '../../../components/Button/CustomButton';
import styles from '../../../assets/jss/pages/SettingSellProductOrganizerStyle';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import FormDialog from '../../../components/Dialog/FormDialog';
import CleanableInput from '../../../components/Input/CleanableInput';
import Validation from '../../../common/Validation';
import InputHasUnit from '../../SeminarManagementOrganizer/inputHasUnit';

const useStyles = makeStyles(styles);

const titleDialog = () => (
    <Box>
        <CustomTypography variant="h6" bold color="info">
            商品販売情報編集
        </CustomTypography>
    </Box>
);

const DialogRegisterSettingProductCompany = ({
    isOpenDialog,
    isCloseDialog,
    infoSettingSell,
    updateSettingSell,
}) => {
    const classes = useStyles();
    const intl = useIntl();
    const [params, setParams] = useState({});
    const [validateResults, setValidateResults] = useState({});

    useEffect(() => {
        if (!_.isEmpty(infoSettingSell)) {
            setParams({
                ...infoSettingSell,

            });
        }
    }, [infoSettingSell]);

    const actionsButton = () => (
        <>
            <Box style={{ margin: 'auto' }}>
                <Button
                    autoFocus
                    gradient
                    onClick={handleSubmitSetting}
                    size="md"
                    color="success"
                    style={{ width: '200px', fontSize: '20px', left: ' 20%' }}
                >
                    <FormattedMessage id="save" />
                </Button>
                <Button
                    autoFocus
                    gradient
                    onClick={handleCloseDialog}
                    size="md"
                    color="danger"
                    style={{ width: '150px', marginRight: '10px', left: ' 80%' }}
                >
                    <FormattedMessage id="cancel" />
                </Button>
            </Box>
        </>
    );

    const handleSubmitSetting = () => {
        if (validate()) {
            isCloseDialog();
            const dataSubmit = {
                ...params,
                cost_free_shipping: params.cost_free_shipping,
                shipping_cost: params.shipping_cost,
            };
            if (_.isNull(params.cost_free_shipping) || params.cost_free_shipping === '') {
                delete dataSubmit.cost_free_shipping;
            }
            updateSettingSell(dataSubmit);
        }
    };

    const validate = () => {
        const validateRules = {
            shipping_cost: [
                () => Validation.isNotEmpty(params.shipping_cost),
            ],
            name_person_in_charge: [
                () => Validation.isNotEmpty(params.name_person_in_charge),
                () => Validation.validateMaxLength(params.name_person_in_charge, 50),
            ],
            phone_number_person_in_charge: [
                () => Validation.isNotEmpty(params.phone_number_person_in_charge),
                () => Validation.validateMaxLength(params.phone_number_person_in_charge, 255),
                () => Validation.validatePhoneNumber(params.phone_number_person_in_charge && params.phone_number_person_in_charge.trim()),
            ],
            email_person_in_charge: [
                () => Validation.isNotEmpty(params.email_person_in_charge),
                () => Validation.validateEmail(params.email_person_in_charge),
            ],
        };

        const validateResult = Validation.validateAllRules(validateRules);

        if (Object.keys(validateResult).length > 0) {
            setValidateResults({ ...validateResult });
            window.scrollTo(0, 0);
            return false;
        }
        setValidateResults({});
        return true;
    };

    const handleSetParams = (field, valueChange) => {
        setParams((prevParams) => ({ ...prevParams, [field]: valueChange }));
    };

    const handleChangePrice = (field, cost) => {
        if (/^\d*$/.test(cost)) {
            const value = cost || '';

            handleSetParams(field, value);
        }
    };

    const handleCloseDialog = () => {
        isCloseDialog();
        setParams(infoSettingSell);
        setValidateResults({});
    };

    const watchPriceChange = (e) => {
        if (!/^\d*$/.test(e.key)) e.preventDefault();
    };

    return (
        <>
            <FormDialog isOpen={isOpenDialog} handleClose={handleCloseDialog} title={titleDialog()} actions={actionsButton()}>
                <GridContainer>
                    <GridItem>
                        <GridContainer className={classes.items}>
                            <GridItem xs={12} sm={3} md={3}>
                                <CustomTypography variant="h7" bold required>
                                    送料
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={3} md={3}>
                                <InputHasUnit
                                    defaultValue={params.shipping_cost}
                                    className={classes.numberInput}
                                    onChange={(value) => handleChangePrice('shipping_cost', value)}
                                    onKeyPress={watchPriceChange}
                                    unit="円"
                                    minValue={0}
                                    error={!!validateResults.shipping_cost}
                                    helperText={validateResults.shipping_cost
                                        ? intl.formatMessage({ id: validateResults.shipping_cost.message }) : ''}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={6} md={6} className={classes.detailItem}>
                                <CustomTypography variant="h7" bold>
                                    ※購入者の商品合計金額に足して請求します。
                                </CustomTypography>
                                <CustomTypography variant="h7" bold>
                                    （送料が無料の場合は”0”と入力してください）
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.items}>
                            <GridItem xs={12} sm={3} md={3} style={{ paddingRight: '0' }}>
                                <CustomTypography variant="h7" bold>
                                    送料が無料になる金額
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={3} md={3}>
                                <InputHasUnit
                                    defaultValue={params.cost_free_shipping}
                                    className={classes.numberInput}
                                    onChange={(value) => handleChangePrice('cost_free_shipping', value)}
                                    onKeyPress={watchPriceChange}
                                    unit="円"
                                    minValue={0}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={6} md={6} className={classes.detailItem}>
                                <CustomTypography variant="h7" bold>
                                    ※購入者の商品合計金額が設定金額を超えた場合に送料を0円にします
                                </CustomTypography>
                                <CustomTypography variant="h7" bold>
                                    （使用しない場合は空欄にしてください）
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.items}>
                            <GridItem xs={12} sm={3} md={3}>
                                <CustomTypography variant="h7" bold required>
                                    お問合せ先情報
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={9} md={9} style={{ marginBottom: '10px' }}>
                                <CustomTypography variant="h7" bold>
                                    ※購入者へ「商品に関するお問合せ先」としてお知らせします。
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.items}>
                            <GridItem xs={12} sm={3} md={3} />
                            <GridItem xs={12} sm={3} md={2}>
                                <CustomTypography variant="h7" bold>
                                    担当者名
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={5} md={6} className={classes.detailItemChild}>
                                <CleanableInput
                                    required
                                    defaultValue={params.name_person_in_charge}
                                    onChange={(value) => handleSetParams('name_person_in_charge', value)}
                                    error={!!validateResults.name_person_in_charge}
                                    helperText={validateResults.name_person_in_charge
                                        ? intl.formatMessage({ id: validateResults.name_person_in_charge.message }) : ''}
                                />
                                <CustomTypography variant="h7">
                                    ※企業の場合は、会社名・所属・担当者名を入力してください。
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.items}>
                            <GridItem xs={12} sm={3} md={3} />
                            <GridItem xs={12} sm={3} md={2}>
                                <CustomTypography variant="h7" bold>
                                    電話番号
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={5} md={6} className={classes.detailItemChild}>
                                <CleanableInput
                                    required
                                    defaultValue={params.phone_number_person_in_charge}
                                    onChange={(value) => handleSetParams('phone_number_person_in_charge', value)}
                                    error={!!validateResults.phone_number_person_in_charge}
                                    helperText={validateResults.phone_number_person_in_charge
                                        ? intl.formatMessage({ id: validateResults.phone_number_person_in_charge.message }) : ''}
                                />
                                <CustomTypography variant="h9">
                                    記入例：045-912-2112 → 0459122112 と入力
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.items}>
                            <GridItem xs={12} sm={3} md={3} />
                            <GridItem xs={12} sm={3} md={2}>
                                <CustomTypography variant="h7" bold>
                                    メールアドレス
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={5} md={6} className={classes.detailItemChild}>
                                <CleanableInput
                                    required
                                    defaultValue={params.email_person_in_charge}
                                    onChange={(value) => handleSetParams('email_person_in_charge', value)}
                                    error={!!validateResults.email_person_in_charge}
                                    helperText={validateResults.email_person_in_charge
                                        ? intl.formatMessage({ id: validateResults.email_person_in_charge.message }) : ''}
                                />
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                </GridContainer>
            </FormDialog>
        </>
    );
};

DialogRegisterSettingProductCompany.defaultProps = {
    isOpenDialog: false,
    isCloseDialog: () => {},
    infoSettingSell: {},
    updateSettingSell: () => {},
};

DialogRegisterSettingProductCompany.propTypes = {
    isOpenDialog: PropTypes.bool,
    isCloseDialog: PropTypes.func,
    infoSettingSell: PropTypes.oneOfType([() => null, PropTypes.object]),
    updateSettingSell: PropTypes.func,
};

export default DialogRegisterSettingProductCompany;
